import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Tabs, Tab, Divider, colors } from '@mui/material';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { Header, Page, PowerBIDashboard } from 'components';
import TableauDashboard, { ShowExportPDFDialog } from '../../../../components/TableauDashboard/TableauDashboard.js';
import OptionsButton from './components/OptionsButton/OptionsButton.js';
import * as actions from '../../actions/DashboardInspectActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: '100%',
		margin: '0 auto',
		padding: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	divider: {
		backgroundColor: colors.grey[300],
	},
	alert: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
}));

const DashboardInspect = (props) => {
	const { match } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const handle = useFullScreenHandle();
	const user = useSelector(state => state.session.user);
	const dashboard = useSelector(state => state.dashboardInspectReducer.dashboard);

	const _getDashboard = () => {
		dispatch(actions.DashboardInspect(match.params.id, user.id));
	};

	const _exportPdf = () => {
		ShowExportPDFDialog();
	};

	const _fullScreen = () => {
		handle.enter();
	};

	useEffect(() => {
		_getDashboard();
	}, []);

	return (
		<Page className={classes.root} title="Inspect">
			{dashboard.type === 'Tableau' ? <Header module="Dashboards" view={dashboard.name ?? 'Inspect'} actions={<OptionsButton exportPdf={_exportPdf} fullScreen={_fullScreen} />} /> : null}
			{dashboard.type === 'PowerBI' ? <Header module="Dashboards" view={dashboard.name ?? 'Inspect'} actions={<OptionsButton fullScreen={_fullScreen} />} /> : null}
			<FullScreen handle={handle}>
				<div className={clsx(classes.content)}>
					{dashboard.type === 'Tableau' ? <TableauDashboard url={dashboard.url} /> : null}
					{dashboard.type === 'PowerBI' ? <PowerBIDashboard url={dashboard.url} reportId={dashboard.serverId} accessToken={dashboard.accessToken} /> : null}
				</div>
			</FullScreen>
		</Page>
	);
};

DashboardInspect.propTypes = {
	match: PropTypes.object.isRequired,
};

export default DashboardInspect;
